import { combineReducers } from 'redux'
import auth from '../stores/auth'
import orders from '../stores/orders'
import order from '../stores/order'
import upload from '../stores/upload'
import invoices from '../stores/invoices'

export default combineReducers({
  auth,
  orders,
  order,
  upload,
  invoices
})
